<div class="relational-entity-list">
  <div class="relational-entity -header">
    <span class="entity-item">{{ MESSAGES?.ZONE_PLAN_DRAWER_ENTITY_LABEL }}</span>
    <span class="entity-item">{{ MESSAGES?.ZONE_PLAN_DRAWER_CATEGORY_LABEL }}</span>
    <span class="entity-item">{{ MESSAGES?.ZONE_PLAN_DRAWER_ALERT_LABEL }}</span>
  </div>
  <div class="relational-entity-container" [style.width.px]="dimension?.width"
    [style.height.px]="dimension?.height">
    <ng-container *ngIf="relationalEntityList?.length; else noEntityList;">      
      <div class="relational-entity" *ngFor="let entity of relationalEntityList;">
        <span class="entity-item -first">{{ entity?.uniqueId }}</span>
        <span class="entity-item">{{ entity?.category | titlecase }}</span>
        <span class="entity-item">{{ entity?.alertsCount }}</span>
      </div>
    </ng-container>
    <ng-template #noEntityList>
      <div class="no-record">{{ MESSAGES?.TEXT_NO_RECORDS }}</div>
    </ng-template>
  </div>
</div>